import * as React from "react";
import {
  SidebarComponent,
  SidebarModel,
  TreeViewComponent,
} from "@syncfusion/ej2-react-navigations";
import { NavigationTreeView } from "./NavigationTreeview/NavigationTreeView";
import { UclRouteObject } from "../../../utils/routes";
import { NavigationExpandModes, SidebarTypes } from "./types";
import { navigationTreeViewStore } from "./NavigationTreeview/stores/NavigationTreeViewStore";
import classNames from "classnames";
import { useEffect } from "react";

export interface AppSideBarProps {
  isOpen: boolean;
  uclRouteObject: UclRouteObject[];
  navigationExpandMode: NavigationExpandModes;
  onNavigationExpandChange?: (sideBarOpen: boolean) => void;
  dockSidebarType?: SidebarTypes;
  showSearchBar?: boolean;
  sideBarSettings?: Omit<SidebarModel, "target" | "className" | "id">;
  navigationTreeRef?: (arg: React.RefObject<TreeViewComponent>) => void;
  useNodeClicked?: boolean;
}
const AppSideBarComponent: React.FC<AppSideBarProps> = (props) => {
  // Setup
  const sideBarRef = React.useRef<SidebarComponent>(null);
  const [sideBarSettings, setSideBarSettings] = React.useState<SidebarModel>();
  const [ready, setReady] = React.useState<boolean>(false);
  const [readyTreeView, setReadyTreeView] = React.useState<boolean>(false);
  const [readySidebar, setReadySidebar] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (props.isOpen) {
      navigationTreeViewStore.open();
    } else {
      navigationTreeViewStore.close();
    }
  }, [props.isOpen]);

  React.useEffect(() => {
    if (readyTreeView && readySidebar) {
      setReady(true);
    }
  }, [readyTreeView, readySidebar]);

  const defaultSideBarSettings: SidebarModel = {
    type: "Push",
    width: 290,
    dockSize: 85,
    enableDock: true,
    enableGestures: false,
    isOpen: props.isOpen,
    created: () => {
      if (!props.isOpen) {
        navigationTreeViewStore.close();
      } else {
        navigationTreeViewStore.open();
      }

      setReadySidebar(true);
    },
  };

  useEffect(() => {
    const settings = {
      ...defaultSideBarSettings,
      ...props.sideBarSettings,
    };

    settings.open = () => {
      props.onNavigationExpandChange?.(true);
      props.sideBarSettings?.open?.();
    };
    settings.close = () => {
      props.onNavigationExpandChange?.(false);
      props.sideBarSettings?.close?.();
    };

    setSideBarSettings(settings);
  }, []);

  return (
    <div>
      {sideBarSettings && (
        <SidebarComponent
          id="sidebar-treeview"
          className={classNames("sidebar-treeview", {
            "dock-column-style": props.dockSidebarType === SidebarTypes.Column,
            "sidebar-treeview-ready": ready,
            "sidebar-treeview-closed": !props.isOpen,
          })}
          ref={sideBarRef}
          target={".content"}
          {...sideBarSettings}
        >
          <NavigationTreeView
            uclRouteObject={props.uclRouteObject}
            sideBarRef={sideBarRef}
            navigationExpandMode={props.navigationExpandMode}
            showSearchBar={props.showSearchBar}
            onReady={() => {
              setReadyTreeView(true);
            }}
            liftUpNavigationRef={props.navigationTreeRef}
            useNodeClicked={props.useNodeClicked}
          />
        </SidebarComponent>
      )}
    </div>
  );
};
export const AppSideBar = AppSideBarComponent;
export default AppSideBar;
